import * as React from 'react';
import {Platform, StyleSheet, View} from 'react-native';
import {Field} from 'redux-form';
import {images} from '../../../assets/icons';
import {useTheme} from '../../../shared/theme';
import {useStyles} from '../../../shared/hooks/styles';
import {DeviceSize} from '../../../shared/theme/helpers';
import {BaseField} from '../../../shared/components/baseField';
import {useSelector} from 'react-redux';
import {themeSelector} from '../../../redux/selectors/runtime/theme';

export default () => {
  const theme = useTheme();
  const themeSettings = useSelector(themeSelector());
  const isInvertedColors = themeSettings.switchColor === 'invert';

  const styles = useStyles(({mediaOnly, platformOnly}) => ({
    selectedBarRow: {
      width: '100%',
      flexDirection: 'row',
      ...mediaOnly(DeviceSize.desktop, {justifyContent: 'center'}, {justifyContent: 'flex-start'}),
      alignItems: 'center',
    },
    searchBarRow: {
      width: '100%',
      alignSelf: 'center',
      ...mediaOnly(DeviceSize.desktop, {marginTop: 0}, {marginTop: 0}),
      marginBottom: 30,
    },
    searchBarField: {
      width: '100%',
      color: theme.color.textColor,
      ...platformOnly('web', {borderColor: theme.color.primaryColor}),
      ...platformOnly('ios', {
        marginBottom: 12,
      }),
      ...platformOnly('android', {
        marginBottom: 8,
      }),
      ...(isInvertedColors && {
        backgroundColor: 'black',
        borderRadius: 8,
        height: 40,
        maxHeight: 40,
      }),
    },
    searchBarFieldInputContainer: {
      height: 20,
      maxHeight: 20,
      paddingBottom: 0,
    },
    searchBarFieldContainer: {
      height: 20,
      maxHeight: 20,
      justifyContent: 'flex-start',
    },
    searchBarFieldIconWrapper: {
      ...platformOnly('web', {height: 40}, {height: 20, minHeight: 20, marginBottom: 10}),
    },
  }));

  return (
    <View style={styles.searchBarRow}>
      <Field
        component={BaseField}
        type='text'
        name='query'
        maxLength={30}
        placeholder='Поиск'
        variant={Platform.OS === 'web' ? 'outlined' : 'standard'}
        smallHeight
        style={StyleSheet.flatten(styles.searchBarField) as any}
        inputContainerStyle={styles.searchBarFieldInputContainer}
        containerStyle={styles.searchBarFieldContainer}
        rightStyle={StyleSheet.flatten(styles.searchBarFieldIconWrapper)}
        right={<images.Search color={theme.color.linkColor} width={24} height={24} />}
      />
    </View>
  );
};
